module.exports = ".map-container {\n  min-height: 600px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/map/reports.map.css
// module id = ./src/app/reports/map/reports.map.css
// module chunks = main